import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { fr } from 'date-fns/locale';
import VolumeChart from './VolumeChart';

const GraphSection = ({
  title,
  colorKey,
  data,
  unitLabel,
  startDate,
  endDate,
  onSearch,
  chartRef,
  loading,
}) => {
  const [pendingStart, setPendingStart] = useState(startDate);
  const [pendingEnd, setPendingEnd] = useState(endDate);

  useEffect(() => {
    setPendingStart(startDate);
    setPendingEnd(endDate);
  }, [startDate, endDate]);

  const handleSearchClick = () => {
    onSearch(pendingStart, pendingEnd);
  };

  return (
    <div className="bg-white border border-gray-200 shadow-lg rounded-lg p-8 mb-8">
      <div className="flex flex-wrap gap-4 justify-center items-end mb-6">
        <div>
          <label className="block text-sm text-gray-600 mb-1">Date de début</label>
          <DatePicker
            selected={pendingStart}
            onChange={setPendingStart}
            locale={fr}
            dateFormat="dd/MM/yyyy"
            className="border border-gray-300 p-2 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm text-gray-600 mb-1">Date de fin</label>
          <DatePicker
            selected={pendingEnd}
            onChange={setPendingEnd}
            locale={fr}
            dateFormat="dd/MM/yyyy"
            className="border border-gray-300 p-2 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <button
          onClick={handleSearchClick}
          disabled={loading}
          className="bg-blue-600 text-white px-6 py-2 rounded-lg shadow-sm hover:bg-blue-700 transition duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? 'Chargement...' : 'Rechercher'}
        </button>
      </div>

      <div ref={chartRef} className="bg-white p-4 rounded-lg">
        <h3 className="text-xl lg:text-2xl font-semibold text-center mb-6 text-gray-800">{title}</h3>
        {loading ? (
          <p className="text-center text-gray-400 py-10">Chargement des données...</p>
        ) : data.length > 0 ? (
          <VolumeChart data={data} colorKey={colorKey} unitLabel={unitLabel} />
        ) : (
          <p className="text-center text-gray-500 py-10">Aucune donnée sur cette période</p>
        )}
      </div>
    </div>
  );
};

export default GraphSection;